import moment from '@narvar/moment-shim';
import { LOCAL_PICKUP } from '../../constants/endpoints';

export const RECEIVE_IS_FETCHING_LOCAL_PICKUP_STATE = 'RECEIVE_IS_FETCHING_LOCAL_PICKUP_STATE';
export const RECEIVE_TOGGLE_LOCAL_PICKUP_INSTRUCTIONS = 'RECEIVE_TOGGLE_LOCAL_PICKUP_INSTRUCTIONS';
export const RECEIVE_LOCAL_PICKUP_INSTRUCTIONS = 'RECEIVE_LOCAL_PICKUP_INSTRUCTIONS';
export const RECEIVE_LOCAL_PICKUP_TIMES = 'RECEIVE_LOCAL_PICKUP_TIMES';
export const RECEIVE_LOCAL_PICKUP_ERROR = 'RECEIVE_LOCAL_PICKUP_ERROR';
export const SELECT_TIMESLOT = 'SELECT_TIMESLOT';

/* eslint-disable-next-line camelcase */
const mapLocalPickupAddress = ({ street_1, street_2, city, state, zip, country }) => ({
  address_line1: street_1,
  address_line2: street_2,
  city,
  country,
  postal_code: zip,
  province: state,
});

const receiveIsFetchingLocalPickup = (isFetching) => ({
  type: RECEIVE_IS_FETCHING_LOCAL_PICKUP_STATE,
  data: {
    isFetching,
  },
});

export const toggleLocalPickupInstructions = () => ({
  type: RECEIVE_TOGGLE_LOCAL_PICKUP_INSTRUCTIONS,
});

export const receivePickupInstructions = (instructions) => ({
  type: RECEIVE_LOCAL_PICKUP_INSTRUCTIONS,
  data: { instructions },
});

export const fetchLocalPickupTimes = () => async (dispatch, getState) => {
  const {
    localPickup: { isFetching, timeslots },
  } = getState();

  if (isFetching || timeslots.length > 0) return;

  dispatch(receiveIsFetchingLocalPickup(true));
  try {
    const {
      returnItems: { returnItems = [] },
      orderInfo: { currentOrderNumber, orderData },
      page: { overrideCode, giftOrder, productType, browserFingerprint },
      retailerSettings: { name: retailerName },
      addresses: { defaultAddressKey, [defaultAddressKey]: address } = {},
      returnOptions: {
        selectedOptionMethodKey,
        returnOptionMethods: { [selectedOptionMethodKey]: { id, carrier } = {} } = {},
      },
    } = getState();

    const response = await fetch(LOCAL_PICKUP({ carrier, retailerName }), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'narvar-tfid': browserFingerprint,
      },
      body: JSON.stringify({
        return_method: id,
        return_carrier: carrier,
        order_number: currentOrderNumber,
        business_address: false,
        return_items: returnItems,
        customer_id: orderData.customer_id,
        return_override_code: overrideCode,
        gift: giftOrder,
        product_type: productType,
        request_date: moment.utc().toJSON(),
        ...mapLocalPickupAddress(address),
      }),
    });
    dispatch(receiveIsFetchingLocalPickup(false));

    const { pickup_dates: pickupDates = [], pickup_slot_id: slotId } = await response.json();

    if (!pickupDates[0]) {
      throw new Error('No pickup dates available');
    }

    const { pickup_date: date, pickup_time_slots: pickupTimeslots } = pickupDates[0];

    dispatch({
      type: RECEIVE_LOCAL_PICKUP_TIMES,
      data: {
        date,
        slotId,
        timeslots: pickupTimeslots.map((timeslot) => ({
          value: timeslot,
          label: timeslot
            .split('-')
            .map((hour) => moment(hour, 'h:mm').format('h:mm A'))
            .join(' - '),
        })),
      },
    });
  } catch (err) {
    dispatch(receiveIsFetchingLocalPickup(false));
    dispatch({
      type: RECEIVE_LOCAL_PICKUP_ERROR,
    });
  }
};

export const selectTimeslot = (selectedTimeslot) => ({
  type: SELECT_TIMESLOT,
  data: {
    selectedTimeslot,
  },
});
